import React from "react";
import "./Nutricos_Banner.css";

const NutricosBanner = () => {
  return (
    <section className="nutricos_banner">
      <div className="container">
        <div className="banner_card">
          <div className="banner_content">
           

            <h2 className="head">
              Nutrition that tastes good and fits into everyday life.
            </h2>

            <p className="text">
              Clean ingredients. Great taste. Daily wellness made simple.
            </p>
          </div>

          <div className="banner_wrapper">
            <img
              src="/assets/images/about_us/why_choose/Picture2.png"
              alt="Nutrition Drink"
              className="banner_img"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default NutricosBanner;